/**
 * Dashboard API Integration
 * Handles dashboard analytics and summaries
 */

import axiosClient from '../axiosClient';
import {
  DashboardSummary,
  WorkspaceDashboardSummary,
} from '../types/DashboardTypes';

/**
 * Dashboard API endpoints
 */
export const dashboardApi = {
  /**
   * Get user's dashboard summary
   */
  getUserDashboardSummary: async (): Promise<DashboardSummary> => {
    try {
      const response = await axiosClient.get('/dashboard/summary');
      console.log('✅ Dashboard summary fetched');
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching dashboard summary:', error);
      throw error;
    }
  },

  /**
   * Get workspace-specific dashboard summary
   */
  getWorkspaceDashboardSummary: async (
    workspaceId: string,
  ): Promise<WorkspaceDashboardSummary> => {
    try {
      const response = await axiosClient.get(
        `/dashboard/workspace/${workspaceId}/summary`,
      );
      console.log('✅ Workspace dashboard summary fetched:', workspaceId);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching workspace dashboard summary:', error);
      throw error;
    }
  },
};

export default dashboardApi;
